/*
 * @Author: 陈红伟 chenhw2019@gmail.com
 * @Date: 2023-10-30 09:47:52
 * @LastEditors: 陈红伟 chenhw2019@gmail.com
 * @LastEditTime: 2023-11-01 15:41:08
 * @FilePath: /seller.sviptrader.com/src/views/shopManage/shopLibrary/list/columns.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import RdColumnTypes from '@/utils/RdColumnTypes';

const partner_role_name = {
	label: '达人商务',
	key: 'name',
	type: 'rdText',
	minWidth: '120',
	isShow: true,
};
const dept_name = {
	label: '部门',
	key: 'dept_name',
	type: 'rdText',
	minWidth: '120',
	isShow: true,
};

const operations = {
	key: 'operations',
	label: '操作',
	mode: 'vertical',
	bigger: false,
	type: RdColumnTypes.rdBtnGroup,
	minWidth: '100',
	fixed: 'right',
	align: 'right',
	isShow: true,
};
export const getColumns = () => {
	const columns = [partner_role_name, dept_name, operations].filter(item => item.isShow);
	return columns;
};
